import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'
import React from 'react'

import { styled } from '~/styled'
import { getExternalAnchorProps } from '~/utilities/uri'

import { navigationMenuBaseItemStyles } from './NavigationMenu.styles'

const DisabledButton = styled('button', {
  base: [
    ...navigationMenuBaseItemStyles,
    'disabled:bg-none',
    'disabled:cursor-default',
    'disabled:opacity-30',
    'disabled:text-text'
  ]
})

const ListItem = NavigationMenuPrimitive.Item

const StyledLink = styled(NavigationMenuPrimitive.Link, {
  base: [
    ...navigationMenuBaseItemStyles,
    'block',
    'no-underline',
    'leading-none'
  ],
  variants: {
    elementType: {
      dropdownItem: [
        'data-active:bg-background-selected',
        'data-active:text-text-selected',
        'data-active:hover:bg-background-selected-hover',
        'data-active:hover:text-text-selected-hover',
        'data-active:active:bg-background-selected-pressed',
        'data-active:active:text-text-selected-pressed',
        'data-active:focus-visible:shadow-[0_0_0_2px_var(--color-primary-800)]',
        'data-active:focus-visible:text-text-selected-focus'
      ],
      link: [
        'data-active:font-semibold',
        'data-active:text-item-(--background-selected)',
        'data-active:after:-translate-x-1/2',
        'data-active:after:absolute',
        'data-active:after:bg-item-(--background-selected)',
        'data-active:after:block',
        'data-active:after:bottom-0',
        'data-active:after:h-0.5',
        'data-active:after:left-1/2',
        'data-active:after:rounded-md',
        'data-active:after:translate-y-0',
        'data-active:after:w-6'
      ]
    }
  }
})

export const NavigationMenuLink = React.forwardRef<
  HTMLAnchorElement,
  Omit<React.ComponentProps<typeof StyledLink>, 'elementType'> & {
    disabled?: boolean
    variant?: React.ComponentProps<typeof StyledLink>['elementType']
  }
>(
  (
    { children, href, disabled, className, variant = 'link', ...props },
    forwardedRef
  ) => (
    <ListItem>
      {disabled ? (
        <DisabledButton disabled className={className}>
          {children}
        </DisabledButton>
      ) : (
        <StyledLink
          href={href}
          ref={forwardedRef as any}
          elementType={variant}
          className={className}
          {...getExternalAnchorProps(href)}
          {...props}
        >
          {children}
        </StyledLink>
      )}
    </ListItem>
  )
)

NavigationMenuLink.displayName = 'NavigationMenuLink'
